/**
 * Macros usable where the user is typing: global macros (no templateId) plus
 * the ones scoped to the active template. A macro is not tied to a report
 * section. Shared by the MacroPopover list, the textarea shortcode expansion
 * and voice "insert macro" so all three see the same set.
 */
export function getAvailableMacros(macros, activeTemplateId) {
    return macros.filter((m) => m.templateId === null || m.templateId === undefined || m.templateId === activeTemplateId);
}
